import React, {useEffect} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {SortableElement} from "react-sortable-hoc";

import WizardGroupsAsideGroup from "./WizardGroupsAsideGroup";
import {WIZARD_GROUP_TYPES} from "../WizardItem/wizardItemInterface";

const SortableItem = SortableElement(({ wizardActiveItem, featureGroup, key, groupIndex }) => {
  return <WizardGroupsAsideGroup wizardActiveItem={wizardActiveItem}
                                 groupIndex={groupIndex}
                                 featureGroup={featureGroup}
                                 key={key}/>
});

const WizardGroupsAsideList = (props) => {

  const {wizardActiveItem, featureGroups, wizardFlowActiveMode, notReceivedWizardGroupFilters, searchText, allFilterGroups} = props;

  if ((wizardFlowActiveMode === WIZARD_GROUP_TYPES.group && !featureGroups.length)
    || (wizardFlowActiveMode === WIZARD_GROUP_TYPES.filter && (!allFilterGroups.length || notReceivedWizardGroupFilters.length))) {
    return <div className="ui-loader"/>
  }

  if (wizardFlowActiveMode === WIZARD_GROUP_TYPES.group) {

    const displayFeatureGroups = searchText ? featureGroups.filter(featureGroup => {
      return (featureGroup.customDisplayName || featureGroup.groupName || "").toLowerCase().includes(searchText.toLowerCase())
    }) : featureGroups;

    return displayFeatureGroups.map((featureGroup, featureGroupIndex) => {
      return <SortableItem wizardActiveItem={wizardActiveItem}
                           index={featureGroupIndex}
                           groupIndex={featureGroupIndex}
                           featureGroup={featureGroup}
                           key={featureGroup.groupName}/>
    })

  }

  const displayFilters = searchText ? allFilterGroups.filter(filterGroup => {
    return (filterGroup.name || "").toLowerCase().includes(searchText.toLowerCase())
  }) : allFilterGroups;

  return displayFilters.map((featureGroup, featureGroupIndex) => {
    return <SortableItem wizardActiveItem={wizardActiveItem}
                         index={featureGroupIndex}
                         groupIndex={featureGroupIndex}
                         featureGroup={featureGroup}
                         key={featureGroup.name}/>
  })

};

WizardGroupsAsideList.propTypes = {
  wizardActiveItem: PropTypes.object.isRequired,
  searchText: PropTypes.string,
  notReceivedWizardGroupFilters: PropTypes.array,
}

const mapStateToProps = (store) => {
  const {featuresGroups} = store.projectScopeNew;
  const {wizardFlowActiveMode} = store.wizardState;
  const {allFilterGroups} = store.featuresFiltersState;

  return {
    featureGroups: featuresGroups,
    wizardFlowActiveMode,
    allFilterGroups,
  };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardGroupsAsideList)
